import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import FeaturesService from 'ember-feature-flags/services/features';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Ember from 'ember';
import { wait } from 'ember-animated';
import Sprite from 'ember-animated/-private/sprite';

const COLLAPSE_DURATION = 200;

export default class WorkspaceSettingsMergeOptionsController extends Controller {
  @service environment!: EnvironmentService;
  @service features!: FeaturesService;

  @tracked autoMergePanelExpanded = false;

  readonly collapseTransitionDuration = COLLAPSE_DURATION;
  *collapseTransition({ removedSprites }: { removedSprites: Sprite[] }) {
    // This makes sure the disappearing panel body doesn't disappear instantly.
    // Otherwise the container will be empty while it animates, which we don't
    // want.
    // eslint-disable-next-line
    for (let _ of removedSprites) {
      if (!Ember.testing) {
        yield wait(COLLAPSE_DURATION);
      }
    }
  }

  @action
  toggleAutoMergePanelExpansion() {
    this.autoMergePanelExpanded = !this.autoMergePanelExpanded;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'workspace-settings/merge-options': WorkspaceSettingsMergeOptionsController;
  }
}
